<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+LEARNING_CENTER.TITLE' | translate }}</span>
      <button mat-icon-button (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="content__body">
      <div class="content__description-section">
        <div class="description-section__header">
          {{ '+LEARNING_CENTER.DESCRIPTION' | translate }}
        </div>

        <div class="description-section__content-wrapper">
          <div class="description-section__content">
            <div class="tutorial__entry" *appHideForRsaUser>
              <app-shepherd-card [type]="SHEPHERD_CARD_TYPES.GRID"></app-shepherd-card>
              <span class="tutorial-entry__content">
                <span class="tutorial-entry__description">{{
                  '+LEARNING_CENTER.LANDING_PAGE_DESCRIPTION' | translate
                }}</span>

                <button
                  mat-raised-button
                  color="primary"
                  (click)="navigateToTutorial(TutorialType.LandingPage)"
                >
                  {{ '+LEARNING_CENTER.START_TOUR' | translate }}
                </button>
              </span>
            </div>

            <div class="tutorial__entry !hidden gt-sm:!flex" *appHideForRsaUser>
              <app-shepherd-card [type]="SHEPHERD_CARD_TYPES.COLUMN"></app-shepherd-card>
              <span class="tutorial-entry__content">
                <span class="tutorial-entry__description">{{
                  '+LEARNING_CENTER.KANBAN_BOARD_DESCRIPTION' | translate
                }}</span>

                <button
                  mat-raised-button
                  color="primary"
                  (click)="navigateToTutorial(TutorialType.KanbanBoard)"
                >
                  {{ '+LEARNING_CENTER.START_TOUR' | translate }}
                </button>
              </span>
            </div>

            <div class="tutorial__entry">
              <app-shepherd-card [type]="SHEPHERD_CARD_TYPES.LIST"></app-shepherd-card>
              <span class="tutorial-entry__content">
                <span class="tutorial-entry__description">{{
                  '+LEARNING_CENTER.KANBAN_INSTALLATIONS_LIST_DESCRIPTION' | translate
                }}</span>

                <button
                  mat-raised-button
                  color="primary"
                  (click)="navigateToTutorial(TutorialType.KanbanInstallationList)"
                >
                  {{ '+LEARNING_CENTER.START_TOUR' | translate }}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
